import { useAccountInfo } from "../lib/accounts";
import { liveItems } from "../lib/domain";
import type { Task } from "../types";
import { Prop } from "./ModalParts";
import { PublicAvatar } from "./PublicAccount";

/** Куда выходит ролик (09.10.2026): в окне публикации аккаунта не было видно вовсе. */
export function AccountProp({ task }: { task: Task }) {
  const item = liveItems(task)[0] ?? task.items[0];
  const account = useAccountInfo(item?.accountId);
  if (!account) return null;
  return <Prop label="Паблик"><PublicAvatar account={account} className="size-7" /><span className="truncate">{account.name}</span></Prop>;
}
